import { PlatformNames } from "../constants";

export enum TargetPlatforms {
  xboxSeriesXS = "xboxSeriesXS",
  xboxOne = "xboxOne",
  windowsStore = "windowsStore",
  pc = "pc",
  epic = "epic",
  steam = "steam",
  nintendoSwitch = "nintendoSwitch",
  nintendoSwitch2 = "nintendoSwitch2",
  ps5 = "ps5",
  ps4 = "ps4",
  android = "android",
  ios = "ios",
  other = "other",
}

export const TargetPlatformsDisplayName = {
  [TargetPlatforms.xboxSeriesXS]: PlatformNames.XboxSeriesXS,
  [TargetPlatforms.xboxOne]: PlatformNames.XboxOne,
  [TargetPlatforms.windowsStore]: PlatformNames.WindowsStore,
  [TargetPlatforms.pc]: PlatformNames.PC,
  [TargetPlatforms.epic]: PlatformNames.Epic,
  [TargetPlatforms.steam]: PlatformNames.Steam,
  [TargetPlatforms.nintendoSwitch]: PlatformNames.NintendoSwitch,
  [TargetPlatforms.nintendoSwitch2]: PlatformNames.NintendoSwitch2,
  [TargetPlatforms.ps5]: PlatformNames.PS5,
  [TargetPlatforms.ps4]: PlatformNames.PS4,
  [TargetPlatforms.android]: PlatformNames.Android,
  [TargetPlatforms.ios]: PlatformNames.iOS,
};
